import AvatarMaleIcon from './AvatarMaleIcon'

export default AvatarMaleIcon
